import { applyMiddleware, compose, createStore as createReduxStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import makeRootReducer from './rootReducer';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

const logger = createLogger({
  // ...options
  // https://github.com/evgenyrodionov/redux-logger#options,
  collapsed: true,
});

const createStore = (initialState = {}) => {
  const middleware = [sagaMiddleware, logger];
  const enhancers = [];
  const composeEnhancers = compose;

  const store = createReduxStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers),
  );
  store.asyncReducers = {};
  sagaMiddleware.run(rootSaga);
  return store;
};

export default createStore;



// WEBPACK FOOTER //
// ./src/redux/store.js